import script from "./Customerlist-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Customerlist-big.vue?vue&type=script&setup=true&lang=js"

import "./Customerlist-big.vue?vue&type=style&index=0&id=6db90488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db90488"]])

export default __exports__